'use client'
import { FC, Dispatch, SetStateAction } from 'react'
import { DayPickerProps, Inventory, VoyageInfo } from '@/root/shared-types'
import { DateTime } from 'luxon'
import { DirectionHeader } from '@/root/modules/tuuleliinid/SelectDateTimePage/components/DirectionHeader'
import { RouteSection } from '@/root/modules/tuuleliinid/SelectDateTimePage/components/RouteSection'
import { useRouteInfoSection } from '@/root/modules/shared/SelectDateTimePage'

interface RouteInfoSectionProps extends DayPickerProps {
  routeInfo: VoyageInfo
  inventory: Inventory
  isLoading: boolean
  sailRefId: number
  setRefIdAndTime: (sailRefId: number, time: string, isNextDay: boolean) => void
  time: string
  dataTestId?: string
  hideRoundtripButton?: boolean
  initialTimestamp?: DateTime
  showDivider?: boolean
  routeAttributes?: Record<string, boolean | string>
  preventUndefinedPackageID?: boolean
  setHideRoundTripButton: Dispatch<SetStateAction<boolean>>
  swapPorts: () => void
}

export const RouteInfoSection: FC<RouteInfoSectionProps> = ({
  routeInfo,
  hideRoundtripButton = false,
  showDivider = false,
  setHideRoundTripButton,
  swapPorts,
  selectedDate,
  onDayClick,
  isDayDisabled,
  time,
  sailRefId,
  setRefIdAndTime,
  inventory,
  isLoading,
  routeAttributes,
  dataTestId = 'departure-card',
  initialTimestamp,
  preventUndefinedPackageID = true,
}) => {
  const { showSwapPorts, handleSetHideRoundTripButton, combinedLoading } = useRouteInfoSection({
    inventory,
    isLoading,
    preventUndefinedPackageID,
    routeAttributes,
    setHideRoundTripButton,
  })

  return (
    <div
      data-testid={dataTestId}
      className="max-w-content mx-auto flex w-full flex-col items-start justify-start gap-10"
    >
      {!showDivider && (
        <DirectionHeader
          hideRoundtripButton={hideRoundtripButton}
          setHideRoundTripButton={handleSetHideRoundTripButton}
        />
      )}
      <RouteSection
        routeInfo={routeInfo}
        inventory={inventory}
        isLoading={combinedLoading}
        sailRefId={sailRefId}
        setRefIdAndTime={setRefIdAndTime}
        selectedDate={selectedDate}
        onDayClick={onDayClick}
        isDayDisabled={isDayDisabled}
        time={time}
        initialTimestamp={initialTimestamp}
        routeAttributes={routeAttributes}
        swapPorts={swapPorts}
        showSwapPorts={showSwapPorts}
      />
    </div>
  )
}
